import PropTypes, { number } from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse, Modal, Table, Row, Col } from "reactstrap"
import { Link, useLocation, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import classname from "classnames"
import "../../assets/css/Layout/Header.css"
//i18n
import { withTranslation } from "react-i18next"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import { connect, useSelector } from "react-redux"
import axios from "axios"
import configure from "configure"
import Select from "react-select"
import Loader from "pages/Separate/Loader"
import ReactSelect from "react-select"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import VerionHistory from "./Version/versionHistory"
import moment from "moment"

const Navbar = props => {
  const [openId, setOpenId] = useState(null)
  const toggleMenu = id => {
    setOpenId(openId === id ? null : id) // Close if already open, otherwise open
  }
  const [expense, setExpense] = useState(false)
  const [margin, setMargin] = useState({ value: 1.5, label: 1.5 })
  const [marginOption, setMarginOption] = useState([
    {
      value: 1.5,
      label: 1.5,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 2.5,
      label: 2.5,
    },
  ])
  const [dashboard, setdashboard] = useState(false)
  const [setting, setSetting] = useState(false)
  const [allcurrency, setAllCurrency] = useState([])
  const [allTechData, setAllTechData] = useState([])
  const [currency, setCurrency] = useState({
    label: "INR",
    value: "INR",
    symbol: "₹",
  })
  const [addCallingModal, setAddCallingModal] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)

  const [isLoading, setLoading] = useState(false)
  const [roles, setRoles] = useState([])

  const [subTotal, setSubTotal] = useState(0)
  const [profit, setProfit] = useState("")
  const [finalCost, setFinalCost] = useState(0)

  // Get roles:
  const allRoles = useSelector(state => state?.Roles?.apiData)

  useEffect(() => {
    setRoles(allRoles.map(item => JSON.parse(item.permission)))
  }, [])
  const handleChange = selectedOption => {
    setMargin(selectedOption)
  }

  useEffect(() => {
    const tempData = [...allTechData]
    setAllTechData(
      tempData.map(tech => ({
        ...tech,
        estimate_cost: tech.days * tech[currency.value],
      }))
    )
  }, [currency, margin])

  useEffect(() => {
    setSubTotal(allTechData.reduce((acc, curr) => acc + curr.estimate_cost, 0))
  }, [allTechData])

  useEffect(() => {
    setFinalCost(subTotal + (subTotal * profit) / 100)
  }, [subTotal])

  const fetchCurrency = async () => {
    setLoading(true)
    setAddCallingModal(true)

    try {
      await axios({
        method: "get",
        url: `${configure.nodeApi}/currency`,

        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        setLoading(false)
        setAllCurrency(
          res.data.data.currency.map(curr => ({
            label: curr.currency,
            value: curr.currency,
            symbol: curr.symbol,
          }))
        )

        // call show technologies api
        showTechnologiesData()
      })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const showTechnologiesData = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/show_technologies`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(async response => {
        // console.log("show_technologies", response)
        if (response.data.data.length > 0) {
          const datas = JSON.parse(response.data.data[0].currency_value)

          setAllTechData(
            datas.map(data => ({
              ...data,
              days: "",
              estimate_cost: 0,
            }))
          )
        }
        setAddCallingModal(true)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
    }
  }

  const handleChangeDays = (value, index) => {
    const tempData = [...allTechData]

    setAllTechData(
      tempData.map((tech, i) => {
        if (i == index) {
          tech.days = value
          tech.estimate_cost = value * tech[currency.value]
        }
        return tech
      })
    )
  }

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 50,
    }),
  }

  function filterInnerArraysById(id) {
    return roles.map(innerArray => {
      return innerArray.filter(element => {
        const parts = element.split(",")
        const elementId = parseInt(parts[0])
        return elementId === id
      })
    })
  }

  const ids = [3, 24, 4, 5, 6]

  const output = roles.map(innerArray =>
    innerArray.filter(element => {
      const parts = element?.split(",")
      const elementId = parseInt(parts[0])
      return ids.includes(elementId)
    })
  )

  const output2 = output.map(innerArray => {
    const element = innerArray[1] // Get the element at index 2 (0-based indexing)
    const parts = element?.split(",")
    return parts?.map(part => parseInt(part)) // Convert to integers
  })

  const calenderUrl = useLocation()

  const calender3 = calenderUrl.pathname
  const usepara = useParams()

  const [shouldShow, setShouldShow] = useState(false)
  const token = secureLocalStorage.getItem("auth_token")
  const [modalOpen, setModalOpen] = useState(false)
  const [boxWidth, setBoxWidth] = useState(0)
  const [news, setNews] = useState("")
  const [versions, setVersions] = useState([])
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setBoxWidth(viewportWidth * 0.95)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  useEffect(() => {
    const now = new Date()
    const day = now.getDay()
    const hour = now.getHours()

    const isTuesdayOrThursday = day === 2 || day === 4
    const isAfter3PM = hour >= 11

    if (isTuesdayOrThursday && isAfter3PM) {
      const fetchCurrentVersion = async () => {
        try {
          const res = await fetchNodeData(() => { }, "currentVersion", token)
          if (res?.success) {
            const today = new Date()
            const todayStr = today.toISOString().split("T")[0]
            setNews(
              res.data.updateType == "new module"
                ? "🔥 Huge Release Dropped! New modules, fixes & more – check the log."
                : res.data.updateType == "updation"
                  ? "✨ New Features Unlocked! See what’s changed in today’s update."
                  : res.data.updateType == "bug fix"
                    ? "🚨 Bug Fix Alert! We’ve rolled out updates – check if your issue is fixed."
                    : "🚀 Today’s the Day! Discover Our Exciting New Release – Now Live! Experience Innovation at Its Best. 🌟"
            )
            if (res?.data.date == todayStr) {
              setShouldShow(true)
            }
          }
        } catch (err) {
          console.error("Failed to fetch current version:", err)
        }
      }
      fetchCurrentVersion()
    }
  }, [])

  const handleOpenModal = async () => {
    try {
      const res = await fetchNodeData(() => { }, "versionControl/")
      if (res.success && res.data) {
        setVersions(res.data.versionData || [])
        setModalOpen(true)
      }
    } catch (err) {
      console.error("Failed to fetch version history:", err)
    }
  }


  return (
    <React.Fragment>
      <div
        className={`topnav ps-1 pe-0 ${calender3 === `${configure.appUrl}calendar` ||
          calender3 === `${configure.appUrl}calender/${usepara.id}`
          ? "d-none"
          : ""
          }`}
        style={{ zIndex: "1001" }}
      >
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${configure.appUrl}`}
                    >
                      <i className="bx bx-home-circle me-2 "></i>
                      {props.t("Dashboard")} {props.menuOpen}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">

                    {filterInnerArraysById(66)
                      .map(item => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${configure.appUrl}staff`}
                        id="topnav-invoice"
                        role="button"
                      >
                        <i className="fa fa-users me-2 "></i>
                        <span>Staff</span>
                      </Link>
                    ) : null}
                  </li>


                  <li className="nav-item dropdown">
                    {filterInnerArraysById(40)
                      .map(item => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        to={`${configure.appUrl}payroll-management/leave-management`}
                        className="nav-link dropdown-toggle arrow-none"
                        style={{ overflow: "hidden" }}
                      >
                        <i className="fas fa-business-time me-2 "></i>
                        Leave Management
                      </Link>
                    ) : null}
                  </li>

                  <li className="nav-item dropdown">

                    {filterInnerArraysById(108)
                      .map(item => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        to={`${configure.appUrl}payroll-management/salary-slip`}
                        className="nav-link dropdown-toggle arrow-none "
                        style={{ overflow: "hidden" }}
                      >
                        <i className="fa fa-book me-2 "></i>
                        Salary Slip
                      </Link>
                    ) : null}
                  </li>


                  <li className="nav-item dropdown">

                    {filterInnerArraysById(109)
                      .map(item => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        to={`${configure.appUrl}payroll-management/salary-process`}
                        className="nav-link dropdown-toggle arrow-none "
                        style={{ overflow: "hidden" }}
                      >
                        <i className="fas fa-universal-access  me-2 "></i>
                        Salary Process
                      </Link>
                    ) : null}
                  </li>


                  <li className="nav-item dropdown">
                    <Link
                      to={`${configure.appUrl}payroll_management/swipe_issues`}
                      className="nav-link dropdown-toggle arrow-none "
                      style={{ overflow: "hidden" }}
                    >
                      <i className="fas fa-hands-helping  me-2 "></i>
                      Swipe & Issues
                    </Link>
                  </li>


                  {filterInnerArraysById(121)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link
                        to={`${configure.appUrl}assessment-tests`}
                        className="nav-link dropdown-toggle arrow-none"
                        style={{ overflow: "hidden" }}
                      >
                        <i className="fas fa-clipboard-list me-2"></i>
                        Assessment
                      </Link>
                    </li>) : null}

                  {filterInnerArraysById(7)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to="#"
                        id="topnav-more"
                        role="button"
                        onClick={() => toggleMenu(3)}
                      >
                        <i
                          className="fa fa-list me-2"
                          style={{ fontSize: "12px" }}
                        ></i>
                        <span>More</span>
                        <span className="arrow-down"></span>
                      </Link>
                      <div
                        className={`dropdown-menu ${openId === 3 ? "show-mobile" : ""
                          }`}
                        aria-labelledby="topnav-more"
                        style={{ left: "0%" }}
                      >

                        {filterInnerArraysById(67)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}freelancer`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span>Freelancer</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(38)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}holiday_list`}
                            id="topnav-form"
                            role="button"
                            style={{ overflow: "hidden" }}
                          >
                            <span>List Of Holidays</span>
                            {/* <div className="arrow-down"></div> */}
                          </Link>
                        ) : null}

                        {filterInnerArraysById(39)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}festival`}
                            id="topnav-form"
                            role="button"
                            style={{ overflow: "hidden" }}
                          >
                            <span>Festival</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(123)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}zithas-sop`}
                            id="topnav-sop"
                            role="button"
                            style={{ overflow: "hidden" }}
                          >
                            <span>Zithas SOP</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(124)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}trainee-management`}
                            id="topnav-trainee"
                            role="button"
                            style={{ overflow: "hidden" }}
                          >
                            <span>Training</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(116)
                          .map(item => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}company-structure`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span>Company Structure</span>
                          </Link>
                        ) : null}

                        <Link
                          className="dropdown-item dropdown-toggle arrow-none"
                          to={`${configure.appUrl}ex-employee-feedback`}
                          id="topnav-feedback"
                          role="button"
                        >
                          <span>Ex-Employee Feedback</span>
                        </Link>
                      </div>
                    </li>
                  ) : null}

                </div>

                <div className="d-flex align-items-center gap-3">

                  {filterInnerArraysById(7)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <div
                        className=" dropdown-toggle cursor-pointer p-0 border-0 bg-transparent "
                        id="topnav-more"
                        onClick={() => toggleMenu(3)}
                      >
                        <i
                          className="fa fa-globe "
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <div
                        className={`dropdown-menu overflow-hidden ${openId === 3 ? "show-mobile" : ""
                          }`}
                        aria-labelledby="topnav-more"
                        style={{ left: "-50px" }}
                      >
                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`#`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>CRM</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`#`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Work</span>

                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.in`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance India</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.com`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance USA</span>
                        </a>

                      </div>
                    </li>
                  ) : null}

                  {/* settings  */}
                  {filterInnerArraysById(13)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li
                      className="nav-item dropdown "
                      onClick={() => toggleMenu(7)}
                    >
                      <Link className="nav-link dropdown-toggle arrow-none text-dark me-0 mt-1 p-0">
                        <i className="bx bx-cog setting-icon"></i>
                      </Link>

                      <div
                        className={classname(
                          `dropdown-menu ${openId === 7 ? "show-mobile" : ""}`,
                          {
                            show: setting,
                          }
                        )}
                      >
                        <div className="d-flex main-dropdown">
                          {/* Teams */}

                          <div className="dropdown-head-1">
                            <h6 className="ps-3 mt-2 fw-bold">Teams</h6>

                            {filterInnerArraysById(91)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/freelancer`}
                                className="dropdown-item"
                              >
                                {props.t("Freelancer")}
                              </Link>
                            ) : null}

                            {/* {filterInnerArraysById(68)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link to="#" className="dropdown-item">
                                {props.t("Consultant")}
                              </Link>
                            ) : null} */}

                            {filterInnerArraysById(69)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}roles`}
                                className="dropdown-item"
                              >
                                {props.t("Roles & Permission")}
                              </Link>
                            ) : null}


                            {filterInnerArraysById(119)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/position-master`}
                                className="dropdown-item"
                              >
                                {props.t("Position Master")}
                              </Link>
                            ) : null}

                          </div>


                          {!filterInnerArraysById(119)
                            .map(item => item[0]?.split(",").map(Number)[2])
                            .includes(1) == true ?
                            <div className="dropdown-head-3">
                              <h6 className="ps-3 mt-2 fw-bold">Salary Structure</h6>

                              <Link
                                to={`${configure.appUrl}setting/employee-types`}
                                className="dropdown-item"
                              >
                                {props.t("Employee Types")}
                              </Link>


                              <Link
                                to={`${configure.appUrl}setting/salary-master`}
                                className="dropdown-item"
                              >
                                {props.t("Salary Master")}
                              </Link>

                              <Link
                                to={`${configure.appUrl}setting/earning-deduction`}
                                className="dropdown-item"
                              >
                                {props.t("Earning / Deduction")}
                              </Link>
                            </div>
                            : null}

                          {/* Setting */}

                          <div className="dropdown-head-6 mt-0">
                            <h6 className="ps-3 mt-2 fw-bold">Setting</h6>

                            {filterInnerArraysById(70)
                              .map(item => item[0]?.split(",")?.map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/companysetting`}
                                className="dropdown-item"
                              >
                                {props.t("Company Setting")}
                              </Link>
                            ) : null}

                            {filterInnerArraysById(73)
                              .map(item => item[0]?.split(",")?.map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/generalsetting`}
                                className="dropdown-item"
                              >
                                {props.t("General Setting")}
                              </Link>
                            ) : null}


                            {filterInnerArraysById(81)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/knowledge-base`}
                                className="dropdown-item"
                              >
                                {props.t("Knowledge Base")}
                              </Link>
                            ) : null}
                            {filterInnerArraysById(122)
                              .map(item => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                to={`${configure.appUrl}setting/assessment`}
                                className="dropdown-item"
                              >
                                {props.t("Assessment")}
                              </Link>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </li>
                  ) : null}


                  {/* credentials */}

                  {filterInnerArraysById(10)
                    .map(item => item[0]?.split(",")?.map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link
                        to={`${configure.appUrl}credentials`}
                        className="border-radius border-0 btn text-dark fs-5 px-0 "
                        title="Credentials"
                      >
                        <i className="fa fa-address-card"></i>
                      </Link>
                    </li>
                  ) : null}

                  {/* Website planet */}

                  {filterInnerArraysById(15)
                    .map(item => item[0]?.split(",")?.map(Number)[2])
                    .includes(1) == true ? (
                    <li
                      className="nav-item dropdown"
                      onClick={() => toggleMenu(8)}
                    >
                      <Link className="nav-link px-0 dropdown-toggle arrow-none text-dark">
                        <button className="border-radius border-0 p-0 btn text-dark ps-0 me-2 fs-5">
                          <i className="bx bx-planet fs-5"></i>
                        </button>
                      </Link>

                      <div
                        className={`dropdown-menu shadow-lg ${openId === 8 ? "show-mobile" : ""
                          }`}
                      >
                        <div
                          className="mt-2 mega-dropdown-menu px-2 dropdown-mega-menu-xl"
                          aria-labelledby="topnav-uielement"
                          style={{
                            width: "27rem",
                            right: 0,
                            left: "auto",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <div>
                                {filterInnerArraysById(57)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to={`${configure.appUrl}currentopening`}
                                  >
                                    <span>Current Opening</span>
                                  </Link>
                                ) : null}

                                {filterInnerArraysById(58)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <Link
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    to={`${configure.appUrl}testimonial`}
                                  >
                                    <span>Testimonial</span>
                                  </Link>
                                ) : null}

                                {filterInnerArraysById(59)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <a
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    // href="https://mars.ztpl.net/casestudies"
                                    id="topnav-utility"
                                    role="button"
                                  >
                                    <span>Case Studies</span>
                                  </a>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div>
                                {filterInnerArraysById(60)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <a
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    // href="https://mars.ztpl.net/gallery"
                                    id="topnav-auth"
                                    role="button"
                                  >
                                    <span>Gallery</span>
                                  </a>
                                ) : null}
                                {filterInnerArraysById(61)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <a
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    // href="https://mars.ztpl.net/EmpTestimonial"
                                    id="topnav-auth"
                                    role="button"
                                  >
                                    <span>Employee Testimonial</span>
                                  </a>
                                ) : null}
                                {filterInnerArraysById(62)
                                  .map(
                                    item => item[0]?.split(",")?.map(Number)[2]
                                  )
                                  .includes(1) == true ? (
                                  <a
                                    className="dropdown-item dropdown-toggle arrow-none"
                                    // href="https://mars.ztpl.net/team"
                                    id="topnav-utility"
                                    role="button"
                                  >
                                    <span>Team Members</span>
                                  </a>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ) : null}

                </div>
              </ul>
            </Collapse>
          </nav>
        </div>
        <div>
          {shouldShow ? (
            <div
              className="marquee-container cursor-pointer"
              onClick={() => handleOpenModal()}
            >
              <div className="marquee-text">
                <div className="container-fluid">
                  <div className="d-flex justify-content-center gap-3">
                    <span>{news}</span>
                    <span className="blink-soft">
                      Click Here{" "}
                      <i className="mdi mdi-cursor-default-click PPC-color"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <Modal
        isOpen={addCallingModal}
        size="xl"
        centered
        id="ResourceEstimation"
      >
        <div
          className="modal-header border-bottom-0"
          style={{ backgroundColor: "#730077" }}
        >
          <div className="col-6 ">
            <h5 className="modal-title mt-0 text-white">Resource Estimation</h5>
          </div>
          <div className="col-5 d-flex justify-content-end">
            <div className="col-6 d-flex justify-content-end">
              <Select
                className="basic-multi-select w-50"
                classNamePrefix="border-radius select"
                styles={colourStyles}
                options={allcurrency}
                value={currency}
                onChange={e => setCurrency(e)}
              />
            </div>
            <div className="">
              <button
                className="btn btn-red ms-3 btn-label"
                onClick={() => {
                  setCurrency({ label: "INR", value: "INR", symbol: "₹" })
                  setAllTechData(
                    allTechData.map(data => ({
                      ...data,
                      days: "",
                      estimate_cost: 0,
                    }))
                  )
                  setProfit("")
                }}
              >
                {" "}
                <i className="bi bi-x-circle label-icon"></i> Clear
              </button>
            </div>
          </div>
          <div>
            <button
              type="button"
              onClick={() => {
                setAddCallingModal(false)
              }}
              className="btn-modal-close "
            >
              <span className="btn-modal-span fs-2">&times;</span>
            </button>
          </div>
        </div>
        <div className="modal-body pt-1">
          <div>
            {/* fixed buttons */}
            <div
              className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
                }`}
            >
              <button
                onClick={() => navigate(-1)}
                className="btn btn-red border-radius fix-btn"
              >
                <i className="dripicons-cross me-2 icon-center"></i>
                <span>Cancel</span>
              </button>
            </div>
            <Row className="">
              <Col col={12}>
                <div className="d-flex justify-content-end">
                  <div className=""></div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end col-md-6"></Col>
              <Col className="d-flex justify-content-end col-md-6">
                <div className=""></div>
              </Col>
            </Row>
            <div
              className="position-relative flow-scroll"
              style={{
                height: "420px",
                overflow: "auto",
                scrollbarWidth: "thin",
              }}
            >
              <Table className="table table-bordered">
                <thead className="position-sticky top-0 left-0 right-0 shadow bg-white">
                  <tr>
                    <th className="col-1 text-center">
                      Id
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-4">
                      Name
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-2 text-center d-none">
                      Per Day
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-1 text-center">
                      Days
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-2 text-center">
                      Estimate Cost
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                  </tr>
                </thead>
                <tbody className="fix-databank-header">
                  {allTechData.length === 0 && <Loader />}
                  {allTechData.map((tech, index) => {
                    return (
                      <tr className="row-hover" key={index}>
                        <td className="text-center py-1">{index + 1}</td>
                        <td className="py-1">{tech.Technology}</td>
                        <td className="text-center d-none">
                          {
                            tech[
                            Object.keys(tech).filter(
                              curr => curr == currency.value
                            )
                            ]
                          }
                        </td>
                        <td className="py-1 d-flex justify-content-center">
                          <input
                            className="form-control edit_row_m w-75"
                            id="days1"
                            type="text"
                            value={tech.days}
                            onChange={e =>
                              handleChangeDays(e.target.value, index)
                            }
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key))
                                event.preventDefault()
                            }}
                          />
                        </td>
                        <td className="text-center py-1">
                          {tech.estimate_cost.toFixed(2)}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div
          className="modal-footer p-1 border-top-0"
          style={{ backgroundColor: "#730077" }}
        >
          <div className="w-100">
            <Table className="table table-bordered mb-0">
              <tbody className="fix-databank-header">
                <tr className="">
                  <td className="col-1 fw-bold bg-white text-end">Times</td>
                  <td className=" text-center" style={{ width: "10%" }}>
                    <div className="">
                      <ReactSelect
                        placeholder="Times"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={marginOption}
                        value={margin}
                        // onChange={e =>
                        //   setMargin({ value: e.value, label: e.value })
                        // }
                        onChange={handleChange}
                        menuPlacement="top"
                      />
                    </div>
                  </td>
                  <td
                    className="fw-bold bg-white text-end"
                    style={{ width: "10%" }}
                  >
                    Capital Cost
                  </td>
                  <td className="text-center" style={{ width: "12%" }}>
                    {currency.symbol + " " + subTotal.toFixed(2) * margin.value}
                  </td>

                  <td className="col-2 fw-bold bg-white text-end">
                    Profit (%)
                  </td>
                  <td className="col-1 text-center">
                    {" "}
                    <input
                      className="form-control border-1 border-secondary edit_row_m"
                      id="days1"
                      type="text"
                      placeholder="%"
                      value={profit}
                      onChange={e => {
                        setProfit(e.target.value)
                        setFinalCost(
                          subTotal + (subTotal * e.target.value) / 100
                        )
                      }}
                      onKeyPress={event => {
                        if (!/[0-9]/.test(event.key)) event.preventDefault()
                      }}
                    />
                  </td>

                  <td
                    className="col-2 fw-bold bg-white text-end fs-5"
                    style={{ color: "#981f77" }}
                  >
                    Total Cost
                  </td>
                  <td
                    className="col-2 text-center fs-5"
                    style={{ color: "#981f77" }}
                  >
                    {currency.symbol +
                      " " +
                      (finalCost * margin.value).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </Modal>

      <div className={`note-sticky-form ${modalOpen ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "6%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Version History</h5>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <VerionHistory versions={versions} />
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
